import { DesktopNav, TabletNav } from 'components';
import React from 'react';
import { View, useIsMobile } from 'hooks';
import MobileNav from './mobileNav/MobileNav';

function Nav() {
  const { view } = useIsMobile();
  const content = () => {
    if (view === View.Mobile) {
      return <MobileNav />;
    }
    if (view === View.Tablet) {
      return <TabletNav />;
    }
    return <DesktopNav />;
  };
  return content();
}

export default Nav;
